import React, { useEffect, useState } from "react";
import axios from "../api/axios";
// Logos
import logo from "../assets/img/logoadutem.png";
import logoblanco from "../assets/img/logoADUTEMblanco.png";
import fotogrupal from "../assets/img/fotogrupal.jpeg";
import fotoprincipal from "../assets/img/fotoprincipal.jpeg";
import cursovacacional from "../assets/img/cursovacacional.jpeg";
import curso from "../assets/img/curso.jpeg";
import fotogeneral from "../assets/img/fotogeneral.jpeg";
import prueba from "../assets/img/prueba.jpg";
import adutemprincipal from "../assets/img/adutemprincipal.jpeg";
// CSS
import "../assets/css/styles.css";

// ==================== IMÁGENES DE FALLBACK (sin depender de servicios externos) ====================
const LOGO_FALLBACK =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' width='80' height='80'>
       <rect width='100%' height='100%' fill='#e0e0e0'/>
       <text x='50%' y='50%' font-size='10' font-family='sans-serif' text-anchor='middle' fill='#888' dy='.3em'>Sin Logo</text>
     </svg>`
  );

const EVENTO_FALLBACK =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' width='800' height='600'>
       <rect width='100%' height='100%' fill='#e0e0e0'/>
       <text x='50%' y='50%' font-size='28' font-family='sans-serif' text-anchor='middle' fill='#888' dy='.3em'>Sin Imagen</text>
     </svg>`
  );

// ==================== HOOK: detectar ancho de pantalla ====================
const useWindowWidth = () => {
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return width;
};

const Inicio = () => {
  const [convenios, setConvenios] = useState([]);
  const [eventos, setEventos] = useState([]);
  const [loadingConvenios, setLoadingConvenios] = useState(true);
  const [loadingEventos, setLoadingEventos] = useState(true);
  const [errorConvenios, setErrorConvenios] = useState(null);
  const [errorEventos, setErrorEventos] = useState(null);

  // ==================== ESTADO PARA EL ZOOM DE IMAGEN (LIGHTBOX) ====================
  const [imagenAmpliada, setImagenAmpliada] = useState(null);
  const abrirImagen = (src) => setImagenAmpliada(src);
  const cerrarImagen = () => setImagenAmpliada(null);

  useEffect(() => {
    if (!imagenAmpliada) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") cerrarImagen();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [imagenAmpliada]);

  const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    };
  };

  // Cargar Convenios
  useEffect(() => {
    const cargarConvenios = async () => {
      try {
        const res = await axios.get("/convenios-inicio", {
          headers: getAuthHeaders(),
        });
        setConvenios(
          (res.data.convenios || []).filter((c) => c.estado === "activo")
        );
      } catch (err) {
        console.error("Error al cargar convenios:", err);
        setErrorConvenios(err.message);
      } finally {
        setLoadingConvenios(false);
      }
    };
    cargarConvenios();
  }, []);

  // Cargar Eventos y Noticias (los 3 más recientes)
  useEffect(() => {
    const cargarEventos = async () => {
      try {
        setLoadingEventos(true);
        const res = await axios.get("/eventos");
        const eventosOrdenados = (res.data.eventos || []).sort(
          (a, b) =>
            new Date(b.createdAt || b.fecha || 0) -
            new Date(a.createdAt || a.fecha || 0)
        );
        setEventos(eventosOrdenados.slice(0, 3));
      } catch (err) {
        console.error("Error cargando eventos:", err);
        setErrorEventos("No pudimos cargar los eventos.");
      } finally {
        setLoadingEventos(false);
      }
    };
    cargarEventos();
  }, []);

  // ==================== CARRUSEL DE CONVENIOS (RESPONSIVE) ====================
  const ConveniosCarrusel = ({ convenios }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const width = useWindowWidth();

    let itemsPerSlide = 3;
    if (width < 992) {
      itemsPerSlide = 2;
    }

    const totalSlides = Math.ceil(convenios.length / itemsPerSlide);

    useEffect(() => {
      if (currentIndex >= totalSlides) {
        setCurrentIndex(0);
      }
    }, [totalSlides, currentIndex]);

    const nextSlide = () => {
      setCurrentIndex((prev) => (prev + 1) % totalSlides);
    };

    const prevSlide = () => {
      setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
    };

    useEffect(() => {
      if (totalSlides <= 1) return;
      const interval = setInterval(nextSlide, 5000);
      return () => clearInterval(interval);
    }, [totalSlides]);

    const itemWidthPercent = 100 / itemsPerSlide;

    return (
      <div className="position-relative">
        <div className="overflow-hidden rounded-3">
          <div
            className="d-flex"
            style={{
              transform: `translateX(-${currentIndex * 100}%)`,
              transition: "transform 0.6s ease-in-out",
            }}
          >
            {Array.from({ length: totalSlides }).map((_, slideIndex) => (
              <div
                key={slideIndex}
                className="d-flex w-100 flex-shrink-0 gap-3 gap-md-4 px-2"
                style={{ minWidth: "100%" }}
              >
                {convenios
                  .slice(
                    slideIndex * itemsPerSlide,
                    slideIndex * itemsPerSlide + itemsPerSlide
                  )
                  .map((conv) => (
                    <div
                      className="flex-grow-1"
                      key={conv.id}
                      style={{
                        minWidth: `calc(${itemWidthPercent}% - 16px)`,
                        maxWidth: `calc(${itemWidthPercent}% - 16px)`,
                      }}
                    >
                      <div className="bg-white rounded-4 shadow-sm p-3 p-md-4 h-100 text-center">
                        <div className="mb-3 mb-md-4">
                          <img
                            src={conv.logo || LOGO_FALLBACK}
                            alt={conv.nombre}
                            className="img-fluid"
                            style={{
                              width: "70px",
                              height: "70px",
                              objectFit: "contain",
                            }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = LOGO_FALLBACK;
                            }}
                          />
                        </div>
                        <h5
                          className="fw-bold text-verde-oscuro mb-0"
                          style={{ fontSize: "clamp(0.9rem, 2.5vw, 1.05rem)" }}
                        >
                          {conv.nombre}
                        </h5>
                      </div>
                    </div>
                  ))}
              </div>
            ))}
          </div>
        </div>

        {totalSlides > 1 && (
          <>
            <button
              onClick={prevSlide}
              className="position-absolute top-50 start-0 translate-middle-y btn btn-light shadow border-0 rounded-circle d-flex align-items-center justify-content-center"
              style={{
                zIndex: 10,
                left: "-8px",
                width: "38px",
                height: "38px",
                padding: 0,
              }}
              aria-label="Anterior"
            >
              ←
            </button>
            <button
              onClick={nextSlide}
              className="position-absolute top-50 end-0 translate-middle-y btn btn-light shadow border-0 rounded-circle d-flex align-items-center justify-content-center"
              style={{
                zIndex: 10,
                right: "-8px",
                width: "38px",
                height: "38px",
                padding: 0,
              }}
              aria-label="Siguiente"
            >
              →
            </button>
          </>
        )}

        {totalSlides > 1 && (
          <div className="d-flex justify-content-center mt-4 gap-2">
            {Array.from({ length: totalSlides }).map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentIndex(i)}
                className={`rounded-circle border-0 ${
                  i === currentIndex ? "bg-success" : "bg-secondary"
                }`}
                style={{
                  width: "11px",
                  height: "11px",
                  opacity: i === currentIndex ? 1 : 0.4,
                }}
                aria-label={`Ir al slide ${i + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {/* ================= NAVBAR ================= */}
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container">
          <a className="navbar-brand" href="/">
            <img
              src={logo}
              alt="Logo ADUTEM"
              className="logo-adutem"
              style={{
                height: "clamp(40px, 8vw, 60px)",
                maxHeight: "60px",
                width: "auto",
              }}
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarMenu"
            aria-controls="navbarMenu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarMenu">
            <ul className="navbar-nav ms-auto align-items-center">
              <li className="nav-item me-lg-5">
                <a className="nav-link" href="/">
                  Inicio
                </a>
              </li>
              <li className="nav-item me-lg-5">
                <a className="nav-link" href="/nosotros">
                  Nosotros
                </a>
              </li>
              <li className="nav-item me-lg-5">
                <a className="nav-link" href="/convenios">
                  Convenios
                </a>
              </li>
              <li className="nav-item me-lg-5">
                <a className="nav-link" href="/eventos">
                  Eventos
                </a>
              </li>
              <li className="nav-item me-lg-5">
                <a className="nav-link" href="/login">
                  Login
                </a>
              </li>
              <li className="nav-item mt-2 mt-lg-0">
                <a className="btn btn-socio px-4 py-2 rounded-1" href="/sersocio">
                  Ser Socio
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* ================= VIDEO PRINCIPAL ================= */}
      <section>
        <div
          className="position-relative w-100"
          style={{
            height: "clamp(320px, 60vw, 500px)",
            overflow: "hidden",
            backgroundColor: "#000",
          }}
        >
          <video
            className="w-100 h-100"
            autoPlay
            muted
            loop
            playsInline
            style={{
              objectFit: "cover",
            }}
          >
            <source src="/video/ADUTEM.mp4" type="video/mp4" />
            Tu navegador no soporta la reproducción de video.
          </video>
        </div>
      </section>

      {/* ================= QUIÉNES SOMOS Y CONVENIOS ================= */}
      <section
        className="py-5 position-relative"
        style={{ backgroundColor: "#f0f7f0" }}
      >
        <svg
          className="position-absolute bottom-0 start-0 w-100"
          viewBox="0 0 1440 200"
          preserveAspectRatio="none"
          style={{ height: "150px", zIndex: 0 }}
        >
          <path
            d="M0,100 C360,0 1080,200 1440,100 L1440,200 L0,200 Z"
            fill="#FFD123"
            opacity="0.8"
          />
        </svg>
        <div className="container position-relative">
          <div className="row align-items-start gy-4">
            <div className="col-12 col-lg-5 mt-lg-5 pt-lg-4">
              <div
                className="text-white bg-verde-oscuro p-4 p-md-5 rounded-4"
                style={{ minHeight: "280px" }}
              >
                <h3
                  className="fw-bold"
                  style={{ fontSize: "clamp(1.2rem, 2.8vw, 1.7rem)" }}
                >
                  ¿Quiénes somos?
                </h3>
                <p
                  className="mt-3 mb-0"
                  style={{ fontSize: "clamp(0.9rem, 1.8vw, 1.05rem)" }}
                >
                  ADUTEM es una asociación de docentes orientada a
                  representar, apoyar y promover el bienestar de sus socios.
                </p>
                <a
                  href="/nosotros"
                  className="btn btn-blanco mt-4 px-3 py-1"
                  style={{ fontSize: "0.9rem" }}
                >
                  Leer más
                </a>
              </div>
            </div>
            <div className="col-12 col-lg-7">
              <div className="p-2 p-md-5">
                <h3 className="fw-bold text-center mb-5">
                  Nuestros Convenios
                </h3>
                {loadingConvenios ? (
                  <div className="text-center py-4">
                    <div
                      className="spinner-border text-success"
                      role="status"
                    ></div>
                  </div>
                ) : errorConvenios ? (
                  <div className="alert alert-danger text-center">
                    No se pudieron cargar los convenios
                  </div>
                ) : convenios.length === 0 ? (
                  <p className="text-center text-muted">
                    Aún no hay convenios disponibles
                  </p>
                ) : (
                  <ConveniosCarrusel convenios={convenios} />
                )}
                <div className="text-center mt-5">
                  <a href="/convenios" className="btn btn-verde px-4 py-2">
                    Ver todos los convenios
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= EVENTOS Y NOTICIAS ================= */}
<section className="py-5" style={{ backgroundColor: "#ffffff" }}>
  <div className="container">
    {/* TÍTULO */}
    <div className="text-center mb-5">
      <h3 className="fw-bold text-verde-oscuro mb-3">
        Eventos y Noticias
      </h3>
      <div
        className="mx-auto"
        style={{
          width: "60px",
          height: "4px",
          backgroundColor: "var(--bs-success, #198754)",
          borderRadius: "10px",
        }}
      />
    </div>

    {/* CONTENIDO */}
    {loadingEventos ? (
      <div className="text-center py-5">
        <div className="spinner-border text-success" role="status"></div>
      </div>
    ) : errorEventos ? (
      <div className="alert alert-danger text-center">{errorEventos}</div>
    ) : eventos.length === 0 ? (
      <div className="alert alert-info text-center py-4">
        No hay eventos disponibles en este momento
      </div>
    ) : (
      <div className="row g-4 justify-content-center">
        {eventos.map((item) => (
          <div className="col-12 col-md-6 col-lg-4" key={item.id}>
            <div
              className="card h-100 border-0 overflow-hidden shadow-sm"
              style={{
                borderRadius: "18px",
                backgroundColor: "#ffffff",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-6px)";
                e.currentTarget.style.boxShadow =
                  "0 14px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "";
              }}
            >
              {/* IMAGEN */}
              <div
                style={{
                  width: "100%",
                  height: "360px",
                  backgroundColor: "#f1f1f1",
                  overflow: "hidden",
                  cursor: "pointer",
                }}
                onClick={() =>
                  abrirImagen(item.imagen_portada || EVENTO_FALLBACK)
                }
                title="Click para ampliar"
              >
                <img
                  src={item.imagen_portada || EVENTO_FALLBACK}
                  alt={item.titulo}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    display: "block",
                  }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = EVENTO_FALLBACK;
                  }}
                />
              </div>

              {/* INFORMACIÓN */}
              <div className="card-body d-flex flex-column p-4 bg-white">
                {/* TIPO DE EVENTO */}
                <div className="mb-2">
                  <span
                    className={`badge rounded-pill px-3 py-2 ${
                      item.tipo_evento === "PRINCIPAL"
                        ? "bg-success text-white"
                        : "bg-light text-verde-oscuro border"
                    }`}
                  >
                    {item.tipo_evento === "PRINCIPAL"
                      ? "Evento principal"
                      : item.tipo_evento === "PROMOCIONAL"
                      ? "Promocional"
                      : "Información"}
                  </span>
                </div>

                {/* TÍTULO */}
                <h5 className="fw-bold text-verde-oscuro mb-2" style={{ lineHeight: "1.3" }}>
                  {item.titulo}
                </h5>

                {/* DESCRIPCIÓN */}
                <p
                  className="text-muted mb-4 flex-grow-1"
                  style={{
                    lineHeight: "1.6",
                    fontSize: "0.95rem",
                  }}
                >
                  {item.descripcion?.length > 120
                    ? item.descripcion.substring(0, 117) + "..."
                    : item.descripcion || "Sin descripción disponible"}
                </p>

                {/* BOTÓN */}
                <div className="mt-auto">
                  {item.tipo_evento === "PRINCIPAL" && item.url_pdf && (
                    <a
                      href={item.url_pdf}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-verde w-100 rounded-pill fw-semibold py-2"
                    >
                       Ver más
                    </a>
                  )}
                  {item.tipo_evento === "PROMOCIONAL" && item.url_externa && (
                    <a
                      href={item.url_externa}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-verde w-100 rounded-pill fw-semibold py-2"
                    >
                      Ver más
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    )}

    {/* VER TODOS */}
    <div className="text-center mt-5">
      <a href="/eventos" className="btn btn-verde px-5 py-2 rounded-pill">
        Ver todos los eventos y noticias
        <span className="ms-2">→</span>
      </a>
    </div>
  </div>
</section>

      {/* ================= LIGHTBOX / ZOOM DE IMAGEN ================= */}
      {imagenAmpliada && (
        <div
          onClick={cerrarImagen}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.85)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <button
            onClick={cerrarImagen}
            aria-label="Cerrar"
            style={{
              position: "absolute",
              top: "20px",
              right: "25px",
              background: "transparent",
              border: "none",
              color: "#fff",
              fontSize: "2.2rem",
              lineHeight: 1,
              cursor: "pointer",
              zIndex: 2001,
            }}
          >
            ×
          </button>
          <img
            src={imagenAmpliada}
            alt="Imagen ampliada"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "90vw",
              maxHeight: "88vh",
              objectFit: "contain",
              borderRadius: "8px",
              boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
            }}
          />
        </div>
      )}

      {/* ================= FOOTER ================= */}
      <footer className="bg-verde-oscuro text-white py-4">
        <div className="container">
          <div className="row align-items-center gy-4">
            <div className="col-12 col-lg-4 text-center text-lg-start">
              <img
                src={logoblanco}
                alt="Logo ADUTEM"
                height="60"
                className="me-3 mb-2"
              />
              <p className="mb-0 small opacity-80">
                Asociación de Docentes de la Universidad Técnica de Manabí
              </p>
            </div>
            <div className="col-12 col-lg-4 text-center">
              <h6 className="fw-bold mb-2 small text-uppercase">Dirección</h6>
              <p className="mb-1 small opacity-90">
                <i className="bi bi-geo-alt me-2"></i> Calle: Chile y Los
                Amigos
              </p>
              <p className="mb-1 small opacity-90">
                <i className="bi bi-telephone me-2"></i> Teléfono: (05) 2632
                200 / 0999162353
              </p>
              <p className="mb-3 small opacity-90">
                <i className="bi bi-envelope me-2"></i> adutem@utm.edu.ec
              </p>
              <h6 className="fw-bold mb-3 small text-uppercase">
                Redes Sociales
              </h6>
              <div className="d-flex justify-content-center gap-4">
                <a
                  href="https://www.instagram.com/adutem2025?igsh=MWU2aXJhZnh1Zjhtag=="
                  className="text-white fs-4 opacity-80"
                >
                  <i className="bi bi-instagram"></i>
                </a>
                <a
                  href="https://www.facebook.com/share/1EQhuaFzqH/?mibextid=wwXIfr"
                  className="text-white fs-4 opacity-80"
                >
                  <i className="bi bi-facebook"></i>
                </a>
                <a
                  href="https://youtube.com/@adutem?si=dluaO2vDTwiUwyfh"
                  className="text-white fs-4 opacity-80"
                >
                  <i className="bi bi-youtube"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-4"></div>
          </div>
          <div className="text-center mt-3 pt-3 border-top border-secondary border-opacity-50">
            <small className="opacity-70">
              ADUTEM 2022 - 2025 © Todos los derechos reservados
            </small>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Inicio;